import Text, { escapeText } from "quill/blots/text"

/**
 * Quill's text blot, serialized without 2.0.3's &nbsp; for every space.
 *
 * getSemanticHTML() writes each space in text as &nbsp; (quill/core/editor.js) so copy and paste inside Quill
 * keeps double spaces. A non-breaking space never wraps, so saved rich text would overflow wherever it is
 * displayed. Quill asks a blot for its own html before falling back to that, so this writes the text the way
 * Quill 2.0.2 did. Registered over Quill's text blot in main.ts.
 */
export default class PlainSpaceText extends Text {
	html (index: number, length: number): string {
		return escapeText(this.value().slice(index, index + length))
	}
}
